import React, { useState, useRef, useLayoutEffect } from 'react';

// ── Inline Tooltip ──────────────────────────────────────────────────────────
const Tooltip = ({ text }) => {
  const [pos, setPos] = useState(null);
  const [shift, setShift] = useState(0); // px correction to keep the bubble on-screen
  const iconRef = useRef(null);
  const bubbleRef = useRef(null);

  const handleMouseEnter = () => {
    if (!iconRef.current || !text) return;

    const rect = iconRef.current.getBoundingClientRect();

    if (text.includes('GIS')) {
      setPos({
        top: rect.bottom + 8,
        left: rect.left - 5,
      });
    } else {
      setPos({
        top: rect.top - 125,
        left: rect.left + rect.width + 5,
      });
    }
    setShift(0); // reset so the clamp effect below recalculates cleanly
  };

  const handleMouseLeave = () => {
    setPos(null);
    setShift(0);
  };

  // Runs after the bubble has actually rendered at `pos`, measures its
  // real bounding box, and nudges it back on-screen if either edge is
  // clipped. Because it reads the live viewport width each time, this
  // works at any screen size without hardcoded breakpoints.
  useLayoutEffect(() => {
    if (!pos || !bubbleRef.current) return;

    const PADDING = 8; // min gap from viewport edge
    const rect = bubbleRef.current.getBoundingClientRect();

    let offset = 0;
    if (rect.left < PADDING) {
      offset = PADDING - rect.left;
    } else if (rect.right > window.innerWidth - PADDING) {
      offset = window.innerWidth - PADDING - rect.right;
    }
    if (offset !== 0) setShift(offset);
  }, [pos]);

  return (
    <span
      style={{ position: 'relative', display: 'inline-flex', alignItems: 'center' }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {/* ⓘ icon */}
      <span
        ref={iconRef}
        style={{
          width: 14,
          height: 14,
          borderRadius: '50%',
          border: '1.5px solid #9CA3AF',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: 9,
          color: '#9CA3AF',
          cursor: 'default',
          userSelect: 'none',
          lineHeight: 1,
          flexShrink: 0,
          marginLeft: 2,
        }}
      >
        i
      </span>

      {/* Bubble — fixed so it escapes overflow:hidden parents */}
      {pos && (
        <span
          ref={bubbleRef}
          style={{
            position: 'fixed',
            top: pos.top,
            left: pos.left,
            transform: `translateX(calc(-50% + ${shift}px))`,
            backgroundColor: '#ffffff',
            color: '#374151',
            padding: '7px 11px',
            borderRadius: 8,
            fontSize: 12,
            whiteSpace: 'normal',
            maxWidth: '220px',
            boxShadow: '0 4px 16px rgba(0,0,0,0.15)',
            zIndex: 9999,
            pointerEvents: 'none',
          }}
        >
          {text}
          {/* Arrow pointing up — counter-shifted so it still points at the icon */}
          <span
            style={{
              position: 'absolute',
              bottom: '100%',
              left: '50%',
              transform: `translateX(calc(-50% - ${shift}px))`,
              borderWidth: 6,
              borderStyle: 'solid',
              borderColor: 'transparent transparent #ffffff transparent',
            }}
          />
        </span>
      )}
    </span>
  );
};

export default Tooltip;